import { ModelController, SizeController, ProductController } from "controllers";

// model stuff
export const existingSKU = async (SKU) => {
    const model = await ModelController.getSKU(SKU);
    return (model === undefined) ? true : false;
}

export const getModel = async (SKU) => {
    const model = await ModelController.getSKU(SKU);
    if (model) {
        return model;
    } else {
        return null;
    }
}

export const getSizes = async () => {
    return await SizeController.getSizes();
}

export const getProductsBySKU = async (SKU) => {
    const products = [];
    try {
        for (const market of ['Sweden', 'France']) {
            const results = await ProductController.getProductByFieldQuery('model', SKU, 500, market);
            products.push(...results);
        };
    } catch (error) {
        console.log(error);
    }

    return products;
}

export const createModel = async (payload) => {
    try {
        await ModelController.create(payload);
    } catch (error) {
        throw new Error(error);
    }
}

export const updateModel = async (payload) => {
    try {
        await ModelController.update(payload);
        const count = await updateProducts(payload);
        return count;
    } catch (error) {
        console.log(error.message);
        throw new Error(error);
    }
}

const handleItemsUpdate = async (log, item, payload) => {
    const { userID, boxID } = log;
    const { imageURLs, name } = payload;

    await ProductController.updateItem(userID, boxID, item.id, { imageURL: imageURLs[0], name, description: name });
}
const updateProducts = async (payload) => {
    const SKU = payload.SKU;
    // STEP 1: find products with model == SKU
    const products = await getProductsBySKU(SKU);
    // STEP 2: loop into them and update (remove SKU and update)
    delete payload.SKU;
    delete payload.updated;
    let count = 0;
    for (const product of products) {
        await ProductController.editProduct(product.barcode, payload);
        count += 1;
        const logs = await ProductController.getProductLogs(product.barcode);
        if (logs.length !== 0) {
            for (const log of logs) {
                const { userID, boxID } = log;
                const item = await ProductController.getItemByBarcode(userID, boxID, product.barcode);
                await handleItemsUpdate(log, item, payload);
            }
        }
    };
    return count;
}

// products
export const createProduct = async (payload) => {
    await ProductController.create(payload);
}

export const checkBarcodes = async (barcodes) => {

    if (!barcodes) {
        return [];
    }

    const alreadyExistingBarcodes = [];
    for (const barcode of barcodes) {
        const exist = await existingProduct(barcode);
        if (exist) {
            alreadyExistingBarcodes.push(barcode);
        }
    };

    return alreadyExistingBarcodes.sort();
}

export const existingProduct = async (barcode) => {
    const product = await ProductController.getProductByBarcode(barcode);
    return product?.barcode ? true : false;
}

// check
export const verifyRequiredFields = (fields) => {
    const { color, attributes, imageURLs, category, tags, cuts, supplier, name, brand, details } = fields;

    const requiredFields = [
        { name: category, message: 'category' },
        { name: color, message: 'color' },
        { name: attributes, message: 'attributes' },
        { name: tags, message: 'tags' },
        { name: cuts, message: 'cuts' },
        { name: details, message: 'details' },
        { name: supplier, message: 'supplier' },
        { name: name, message: 'name' },
        { name: brand, message: 'brand' },
        { name: imageURLs, message: 'picture' },
    ];
    for (const field of requiredFields) {
        if (!field.name.length) {
            throw new Error(`Please add ${field.message}.`);
        }
    }
}

// Barcode functions
export const addToString = (string, number) => {
    const result = Number(string) + number;
    return barcodify(result, string.length);
}
export const subToString = (string, number) => {
    const result = Number(string) - number;
    return barcodify(result, string.length);
}

export const barcodify = (input, minimum) => {

    if (!input || !minimum) {
        return null;
    }

    let value = input;
    if (typeof (input) === 'string') {
        value = Number(input);
    }

    return value.toLocaleString('en-US', { minimumIntegerDigits: minimum, useGrouping: false });
}

// Range
const range = (start, end) => {
    const result = [];
    for (let i = start; i <= end; i++) {
        result.push(i);
    }
    return result;
}

export const createRange = (row) => {
    const r = range(Number(row.startBarcode), Number(row.endBarcode));
    const result = r.map(number => {
        return barcodify(number, row.startBarcode.length);
    });
    return result;
}
